import { AttachmentAsset } from "../models/standard/AttachmentAsset";

const isValidTimestamp = (
  value: number | string | null | undefined
): value is number | string => {
  if (value === null || value === undefined) return false;

  const ms = typeof value === "string" ? Number(value) : value;

  // 0 or negative = “no date” in your backend
  if (!Number.isFinite(ms) || ms <= 0) return false;

  return true;
};

const toDate = (value: number | string | null | undefined): Date | null => {
  if (!isValidTimestamp(value)) return null;

  const ms = typeof value === "string" ? Number(value) : value;
  const d = new Date(ms);

  return Number.isNaN(d.getTime()) ? null : d;
};

export const getPrimaryDate = (
  attachment: AttachmentAsset
): { date: Date | null; fromShooting: boolean } => {
  const { shootingDate, creationDate, fileModifiedDate, creationDateDataObject } = attachment;

  const shooting = toDate(shootingDate as any);
  const fileMod = toDate(fileModifiedDate as any);
  const creation = toDate(creationDate as any);
  const creationDO = toDate(creationDateDataObject as any);

  // prefer shooting date if it exists and is > 0
  if (shooting) return { date: shooting, fromShooting: true };
  if (fileMod) return { date: fileMod, fromShooting: false };
  if (creation) return { date: creation, fromShooting: false };
  if (creationDO) return { date: creationDO, fromShooting: false };

  return { date: null, fromShooting: false };
};

export const sortByAttachmentDateDesc = (
  a: AttachmentAsset,
  b: AttachmentAsset
): number => {
  const { date: dateA } = getPrimaryDate(a);
  const { date: dateB } = getPrimaryDate(b);

  if (!dateA && !dateB) return 0;
  if (!dateA) return 1; 
  if (!dateB) return -1;  

  // newest first (includes time)
  return dateB.getTime() - dateA.getTime();
};
